'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RadioComponent } from './radio/component';
import { RadioGroupComponent } from './radiogroup/component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule
  ],
  declarations: [RadioComponent, RadioGroupComponent],
  exports     : [RadioComponent, RadioGroupComponent]
})
export class LKRadio {
}
